import ReactSelect from 'react-select'
import { CountryField } from '@payloadcms/plugin-form-builder/types';
import { Controller, Control, FieldValues, FieldErrorsImpl } from 'react-hook-form'
import { countryOptions } from './options'
import { Error } from '../Error'
import { Width } from '../Width'

import classes from './index.module.scss'
import { useState } from 'react';

export const Country: React.FC<
  CountryField & {
    control: Control<FieldValues, any>
    errors: Partial<
      FieldErrorsImpl<{
        [x: string]: any
      }>
    >
  }
> = ({ name, label, width, control, required, errors }) => {
  const [hasValue, setHasValue] = useState(false);
  return (
    <Width width={width ? width.toString() : undefined}>
      <div className={classes.select}>
        <Controller
          control={control}
          rules={{ required }}
          name={name}
          defaultValue=""
          render={({ field: { onChange, value } }) => (
            <ReactSelect
              instanceId={name}
              options={countryOptions}
              value={countryOptions.find(c => c.value === value)}
              onChange={val => {
                onChange(val.value);
                setHasValue(val.value.length > 0);
              }}
              className={classes.reactSelect}
              classNamePrefix="rs"
              inputId={name}
            />
          )}
        />
        <label htmlFor={name} className={[classes.label, hasValue && classes.notEmpty].join(' ')}>
          {label}
        </label>
        {required && errors[name] && <Error />}
      </div>
    </Width>
  )
}
